/**
 * Relation copy method.
 */
export enum RelationCopyMethod {
    /**
     * Keep
     */
    Keep = "Keep",

    /**
     * Remove
     */
    Remove = "Remove",

    /**
     * Copy
     */
    Copy = "Copy",

    /**
     * Ignore
     */
    Ignore = "Ignore",
}
